import {is_permit, showNotification} from "../Common";
import {default as Lang} from "../lang/Lang";
import API from "../AxoisClient";
import Swal from 'sweetalert2'
import {ShowRecords} from "../ShowRecords";
import * as React from "react";
import { kebabCase } from 'lodash';


export type ActionButtonsType = "Activate" | "DeActivate" | "Delete";
export type ActionButtons = {
  label: string;
  class: string;
  onClick?: () => void;
  show: boolean;
};

export interface ActionButtonSchema {
  records: React.RefObject<ShowRecords>;
  url: string;
  module?: string;
  buttons?: Array<ActionButtonsType>;
  extraActions?: Array<ActionButtons>
}


export const actionButton = (props: ActionButtonSchema) => {

  const ActionButtons: ActionButtons[] = [
    {label: 'Activate',  "class": "btn btn-sm btn-primary", "onClick" : () => actions('active'), show: is_permit(`${props.module}.update`)},
    {label: 'DeActivate',  "class": "btn btn-sm btn-warning", "onClick" : () => actions('inactive'), show: is_permit(`${props.module}.update`)},
    {label: 'Delete', "class": "btn btn-sm btn-danger", "onClick" : () => actions('delete'), show: is_permit(`${props.module}.delete`)},
  ];

  if(props.extraActions !== undefined) {
    props.extraActions.forEach((extraAction) => {
      // If onClick is not provided, default to calling the actions function
      const onClickHandler = extraAction.onClick || (() => actions(kebabCase(extraAction.label)));
      
      const actionButton: ActionButtons = {
        label: extraAction.label,
        class: extraAction.class,
        onClick: onClickHandler,
        show: extraAction.show
      };
      ActionButtons.push(actionButton);
    });
  }
       
  function actions(type: string) {

    Swal.fire({
      title: Lang.is_sure,
      text: Lang.getString(`${type}_confirm`),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.value) {
        let ids: any = props.records.current.state.selected;
        API.post(props.url, {ids, action: type}).then((response : any) => {
          if(response.data.status === true){
            props.records.current.fetchData();
            showNotification('success', response.data.message)
          } else {
            showNotification('error', response.data.message)
          }
        }).catch(() => {});
      }
    })
  }
  if(props.buttons === undefined) {
    return ActionButtons;
  } else {
    return ActionButtons.filter((b: any) => props.buttons.indexOf(b.label) > -1);
  }
}